import React from 'react';
import { HashRouter } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import PropTypes from 'prop-types';
import Header from './Components/Header';
import Overview from './Routes/Municipal/Overview';
import Municipality from './Routes/Municipal/Municipality'
import { Base, Right, Clearfix, Left } from './Symbols/layout';
import CrossPromo from './Components/CrossPromo';
import Cities from './Components/Cities';
import Suggest from './Components/Suggest';
import ScrollToTop from './Components/ScrollToTop';
import E404 from './Routes/Municipal/E404';

export default class App extends React.PureComponent {

	ref = React.createRef();

	render() {
		return <HashRouter>
			<ScrollToTop scrollContainer={this.ref}>
				<Base innerRef={this.ref}>
					<Switch>
						<Route
							exact
							path="/"
							render={() => (
								<Overview
									year={this.props.year}
									rootUrl={this.props.rootUrl}
								/>
							)}
						/>
						<Route
							exact
							path="/obec/:id"
							render={({ match }) => (
								<Municipality
									id={match.params.id}
									year={this.props.year}
									rootUrl={this.props.rootUrl}
								/>
							)}
						/>
						<Route
							render={() => <>
								<Header canUpdate={false} />
								<Left>
									<E404 year={this.props.year} />
								</Left>
							</>}
						/>
					</Switch>

					<Right>
						<Suggest rootUrl={this.props.rootUrl} />

						<CrossPromo links={this.props.links} />

						<Cities />

					</Right>
					<Clearfix />
				</Base>
			</ScrollToTop>
		</HashRouter>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	year: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	links: PropTypes.arrayOf(PropTypes.shape({
		url: PropTypes.string,
		text: PropTypes.string
	}))
};

App.defaultProps = {
	links: []
};
